module.exports = __webpack_public_path__ + "static/media/mascot.9d198f3c.png";